import React from 'react';

import { Button } from '@trqk/components';

interface CallToActionProps {
    config: SetUpGapAnalysisCallToActionConfig;
}

export const CallToAction = ({ config }: CallToActionProps): JSX.Element => (
    <div className="grid mt-4" style={{ gridTemplateColumns: 'auto 230px' }}>
        <p className="text-sm">{config.description}</p>
        <div className="justify-self-end">
            <Button
                addClasses="flex-none"
                autoWidth={true}
                color="secondary-dark-bg"
                handleClick={config.handleClick}
            >
                <p className="text-center px-4">{config.buttonLabel}</p>
            </Button>
        </div>
    </div>
);
